import { storage } from '@/components/Storage.js';

export const onlineIndicator = {
    view: function () {
        return m("span.label[style='margin-left:5px']", {
            class: storage.online ? 'label-success' : 'label-danger',
            config: function (element, isInitialized) {
                if (!isInitialized) {
                    document.addEventListener('onlineChange', function (e) {
                        element.innerHTML = (e.detail.online ? 'online' : 'offline');
                        if (e.detail.online) {
                            element.classList.remove('label-danger');
                            element.classList.add('label-success');
                        } else {
                            element.classList.remove('label-success');
                            element.classList.add('label-danger');
                        }
                    });
                }
            }
        }, storage.online ? 'online' : 'offline');
    }
};